

export default {
  liveStatistics:{
    id: 'ID',
    title: 'Titel',
    hostname: 'Hostname',
    cpu: 'CPU-Auslastung',
    memory: 'Arbeitsspeicher-Auslastung',
    progessbars: {
      cpu: '%{value} %',
      memory: '%s / %s GiB'
    }
  },
  vserver_template: {
    DEBIAN: 'Debian',
    DEBIAN_10: 'Debian 10 (Buster)',
    DEBIAN_9: 'Debian 9 (Stretch)',
    DEBIAN_8: 'Debian 8 (Jessie)',
    UBUNTU: 'Ubuntu',
    'UBUNTU_19.10': 'Vorabversion: Ubuntu 19.10 (Eoan Ermine)',
    'UBUNTU_19.04': 'Ubuntu 19.04 (Disco Dingo)',
    'UBUNTU_18.10': 'Ubuntu 18.10 (Cosmic)',
    'UBUNTU_18.04': 'Ubuntu 18.04 (Bionic) LTS',
    'UBUNTU_17.10': 'Ubuntu 17.10 (Artful)',
    'UBUNTU_16.04': 'Ubuntu 16.04 (Xenial) LTS',
  },
  packages: {
    STARTER: 'Starter',
    PRO: 'Profi',
    ADVANCED: 'Erfahrener',
    EXPERT: 'Experte',
    GALAXY: 'Galaxie'
  },
  general:{
    cores:'Kerne',
    memory:'RAM',
    disk:'Festplatte',
    price:'Preis',
    backups:'Sicherung',
    max_backups:'Sicherung',
    addresses_v4:'IP V4 Adressen'

  }
}



// WEBPACK FOOTER //
// ./src/lang/de/vservers.js